import { render, staticRenderFns } from "./MenteeRegistrationIntro.vue?vue&type=template&id=4737747d&scoped=true&"
import script from "./MenteeRegistrationIntro.vue?vue&type=script&lang=js&"
export * from "./MenteeRegistrationIntro.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4737747d",
  null
  
)

export default component.exports